import { render, staticRenderFns } from "./CompIndex.vue?vue&type=template&id=f6693198&scoped=true"
import script from "./CompIndex.vue?vue&type=script&lang=js"
export * from "./CompIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6693198",
  null
  
)

export default component.exports